import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../../../../components/src/lib/home/home.component';
import { routeGuardFn } from '../../../../components/src/lib/shared/services/route-guard.service';
import { LoginComponent } from '../../../../components/src/lib/login/login.component';
import { loginRouteGuardFn } from '../../../../components/src/lib/shared/services/login-guard-service';
import { LogoutComponent } from '../../../../components/src/lib/shared/logout/logout.component';
import { ZiroSearchComponent } from '../../../../components/src/lib/helpdesk/search/search.component';
import {
  ziroFormConfirmRouteChangeGuardFn,
  ZiroFormConfirmRouteChangeService,
} from '../../../../components/src/lib/forms/ziro-form-confirm-route-change.service';
import { deskphoneRouteGuardFn } from '../../../../components/src/lib/shared/services/activate-deskphone-route-guard.service';
import { SystemStatusComponent } from '../../../../components/src/lib/system-status/system-status.component';
import { ZiroCdrDumpComponent } from '../../../../components/src/lib/cdr-dump/cdr-dump.component';
import { SupportComponent } from '../../../../components/src/lib/shared/support/support.component';
import { zpmHelpdeskRoutes } from './zpm-helpdesk-routes';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [routeGuardFn],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;pages.home.title',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginRouteGuardFn],
    data: {
      title: 'tkey;pages.login.title',
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [routeGuardFn],
  },
  {
    path: 'search',
    component: ZiroSearchComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    data: {
      title: 'tkey;search.title',
    },
    children: [
      {
        path: '?query',
        component: ZiroSearchComponent,
        canActivate: [routeGuardFn],
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'admin',
    loadChildren: () => import('../../../../components/src/lib/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'ziro-support',
    loadChildren: () =>
      import('../../../../components/src/lib/support/ziro-support.module').then((m) => m.ZiroSupportModule),
  },
  { path: 'zero-touch', redirectTo: 'automations' },
  {
    path: 'automations',
    loadChildren: () =>
      import('../../../../components/src/lib/automations/automations.module').then((m) => m.AutomationsModule),
  },
  {
    path: 'self-serve',
    loadChildren: () =>
      import('../../../../components/src/lib/self-serve/self-serve.module').then((m) => m.SelfServeModule),
  },
  { path: 'activate', canActivate: [routeGuardFn, deskphoneRouteGuardFn], children: [] },
  { path: 'report', redirectTo: 'reports' },
  { path: 'control', redirectTo: 'reports' },
  {
    path: 'reports',
    loadChildren: () =>
      import('../../../../components/src/lib/reporting/reporting.module').then((m) => m.ReportingModule),
  },
  { path: 'system-status', redirectTo: 'system-health-status', pathMatch: 'full' },
  {
    path: 'system-health-status',
    component: SystemStatusComponent,
    data: {
      title: 'tkey;system_status.title',
    },
  },
  {
    path: 'emergency-calling-management',
    loadChildren: () =>
      import('../../../../components/src/lib/emergency-calling/emergency-calling.module').then(
        (m) => m.EmergencyCallingModule,
      ),
  },
  {
    path: 'resource-account-management',
    loadChildren: () =>
      import('../../../../components/src/lib/resource-accounts/resource-account.module').then(
        (m) => m.ResourceAccountModule,
      ),
  },
  {
    path: 'call-queue-management',
    loadChildren: () =>
      import('../../../../components/src/lib/teams-call-queues/teams-call-queue.module').then(
        (m) => m.TeamsCallQueueModule,
      ),
  },
  {
    path: 'auto-attendant-management',
    loadChildren: () =>
      import('../../../../components/src/lib/teams-auto-attendants/teams-auto-attendant.module').then(
        (m) => m.TeamsAutoAttendantModule,
      ),
  },

  {
    path: 'search',
    component: ZiroSearchComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;search.title',
    },
  },
  {
    path: 'cdr-dump',
    component: ZiroCdrDumpComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;cdr_dump.title',
    },
  },
  {
    path: 'support',
    component: SupportComponent,
    pathMatch: 'full',
  },
  {
    path: 'migrations',
    loadChildren: () =>
      import('../../../../components/src/lib/migrations/migrations.module').then((m) => m.MigrationsModule),
  },
  {
    path: 'helpdesk',
    loadChildren: () =>
      import('../../../../components/src/lib/helpdesk/zpm-helpdesk.module').then((m) => m.ZpmHelpdeskModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('../../../../components/src/lib/helpdesk/zpc-helpdesk.module').then((m) => m.ZpcHelpdeskModule),
  },
  ...zpmHelpdeskRoutes,
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  providers: [ZiroFormConfirmRouteChangeService],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
